import { render, staticRenderFns } from "./buyGetCoupon.vue?vue&type=template&id=352a5a30&scoped=true&"
import script from "./buyGetCoupon.vue?vue&type=script&lang=ts&"
export * from "./buyGetCoupon.vue?vue&type=script&lang=ts&"
import style0 from "./buyGetCoupon.vue?vue&type=style&index=0&id=352a5a30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352a5a30",
  null
  
)

export default component.exports